import { useMemo } from 'react';
import { hierarchyToLinear } from '../utils/globalUtils';
import { useOrgCode } from '../queries/useCurrentUser';
import { useTeamsHierarchy } from '../queries/useTeams';

/**
 * Shared hook for accessing common teams data. Reads the hierarchical teams
 * tree and the current user's orgCode from the SWR-backed bootstrap caches.
 *
 * @returns {{
 *   teamsHierarchy: Array,
 *   teamsLinear: Array,
 *   orgCode: string,
 * }}
 */
export function useTeamsData() {
  const teamsHierarchy = useTeamsHierarchy();
  const orgCode = useOrgCode();

  const teamsLinear = useMemo(() => hierarchyToLinear(teamsHierarchy), [teamsHierarchy]);

  return { teamsHierarchy, teamsLinear, orgCode };
}
